import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import ItemTypeService from "../../services/item/ItemTypeService";
import { loadingItemTypeDropdown } from "../../store/slices/item/itemTypeSlice";

export const useItemType = () => {
  const dispatch: AppDispatch = useDispatch();

  const { itemTypeDropdown } = useSelector(
    (state: RootState) => state.itemType
  );

  const fetchItemTypeDropdown = async () => {
    try {
      const response = await ItemTypeService.fetchDropdown();

      const mappedResponse = response.map((item: any) => ({
        ...item,
        code: Number(item.code),
      }));

      dispatch(loadingItemTypeDropdown(mappedResponse));
    } catch (error) {
      console.error("Error al cargar item types:", error);
    }
  };

  return {
    itemTypeDropdown,
    fetchItemTypeDropdown,
  };
};
